/* eslint-disable */

/* Correct OS & Browser Check */
var ua = navigator.userAgent, 
	checker = { 
		os : { 
			iphone : 		ua.match(/iPhone/), 
			ipod : 			ua.match(/iPod/), 
			ipad : 			ua.match(/iPad/), 
			blackberry : 	ua.match(/BlackBerry/), 
			android : 		ua.match(/(Android|Linux armv6l|Linux armv7l)/), 
			linux : 		ua.match(/Linux/), 
			win : 			ua.match(/Windows/), 
			mac : 			ua.match(/Macintosh/) 
		}, 
		ua : { 
			ie : 		ua.match(/MSIE/), 
			ie6 : 		ua.match(/MSIE 6.0/), 
			ie7 : 		ua.match(/MSIE 7.0/), 
			ie8 : 		ua.match(/MSIE 8.0/), 
			ie9 : 		ua.match(/MSIE 9.0/), 
			ie10 : 		ua.match(/MSIE 10.0/), 
			ie11 : 		ua.match(/MSIE 11.0/), 
			opera : 	ua.match(/Opera/), 
			firefox : 	ua.match(/Firefox/), 
			chrome : 	ua.match(/Chrome/), 
			safari : 	ua.match(/(Safari|BlackBerry)/) 
		} 
	};

/* Correct Image Load Check */
function isImageOk(img) { 
	if (!img.complete) { 
		return false;
	}
	if (typeof img.naturalWidth !== undefined && img.naturalWidth === 0) { 
		return 'stop';
	}
	return true;
}

/* Check Whether the Numbers are Approximately Equal */
function checkN(a, b, x) { 
	"use strict";
	
    if ((a > b && a - x <= b) || (b > a && b - x <= a)){
        return true;
    } else {
        return false;
    }
}

// jQuery plugins

jQuery(document).ready(function() {

	/* Menu item custom colors */
	(function ($) { 
		$('.menu-item > a[data-color]').each(function () {
			$(this).attr('style', $(this).data('color'));
		} );
	} )(jQuery);

	/* Header Top Hide Toggle */
	(function ($) { 
		$('.header_top_but').on('click', function () { 
			var headerTopBut = $(this), 
				headerTopButArrow = headerTopBut.find('> span'), 
				headerTopOuter = headerTopBut.parents('.header_top').find('.header_top_outer');
			
			if (headerTopBut.hasClass('opened')) {
				// headerTopOuter.slideUp();
				
				headerTopButArrow.removeClass('seasidetms_theme_icon_slide_top').addClass('seasidetms_theme_icon_slide_bottom');
				
				headerTopBut.removeClass('opened').addClass('closed');
			} else if (headerTopBut.hasClass('closed')) {
				headerTopOuter.slideDown();
				
				headerTopButArrow.removeClass('seasidetms_theme_icon_slide_bottom').addClass('seasidetms_theme_icon_slide_top');
				
				headerTopBut.removeClass('closed').addClass('opened');
			}
		} );
	})(jQuery);

	/* Category Menu JS */

	(function ($) {
		var openBtn = $('.bot_cat_button'),
		slideMenu = $('.bot_nav_cat_wrap'),
		headerBotClass = $('.header_bot');
		
		if (seasidetms_media_width() > 1024) {
			if (slideMenu.hasClass("cat_open_default")) {
				openBtn.addClass("active");
				slideMenu.addClass("active");
				slideMenu.slideDown(300);
			}
		} else {
			slideMenu.slideUp(0);
			openBtn.removeClass("active");
			slideMenu.removeClass("active");
		}

		openBtn.on("click", function() {
			if (slideMenu.is(':hidden')) {
				slideMenu.slideDown(300);
				openBtn.addClass("active");
				openBtn.removeClass("close");
			} else {
				slideMenu.slideUp(300);
				openBtn.removeClass("active");
				openBtn.addClass("close");
				slideMenu.removeClass("active");
			}
		});

		$(window).on('scroll', function() {
			if (seasidetms_media_width() > 1024) {
				if (headerBotClass.hasClass("header_bot_scroll") && slideMenu.hasClass("cat_open_default")) {
					openBtn.removeClass("active");
					slideMenu.slideUp(300);
				} else if (!headerBotClass.hasClass("header_bot_scroll") && slideMenu.hasClass("cat_open_default") && !openBtn.hasClass("close")) {
					openBtn.addClass("active");
					slideMenu.slideDown(300);
				}
			}
		});

		$(window).on('debouncedresize', function() {
			if ( 
				!checker.os.iphone && 
				!checker.os.ipod && 
				!checker.os.ipad && 
				!checker.os.blackberry && 
				!checker.os.android 
			) {
				if (seasidetms_media_width() > 1024) {
					return;
				} else {
					slideMenu.slideUp(300);
					openBtn.removeClass("active");
					slideMenu.removeClass("active");
				}
			}
		});
	})(jQuery);

	(function ($) {
		var main_menu_mob_btn = $('.resp_bot_nav_outer'),
		main_menu_mob = $('.bot_nav_wrap nav'),
		cat_menu_mob_btn = $('.bot_cat_button'),
		cat_menu_mob = $('.bot_nav_cat_wrap');

		main_menu_mob_btn.on("click", function() {
			if (cat_menu_mob_btn.hasClass('active')) {
				cat_menu_mob.slideUp();
				cat_menu_mob_btn.removeClass('active');
			}
		});

		cat_menu_mob_btn.on("click", function() {
			if (main_menu_mob_btn.hasClass('active')) {
				main_menu_mob.slideUp();
				main_menu_mob_btn.removeClass('active');
			}
		});

	})(jQuery);

	(function ($) {
		var main_menu_mob_btn = $('.resp_mid_nav_outer'),
		main_menu_mob = $('.mid_nav_wrap nav'),
		main_menu_ico = $('.resp_mid_nav');

		main_menu_mob_btn.on("click", function() {
			if(!main_menu_mob_btn.hasClass("active")) {
				main_menu_mob.slideDown('400');
				main_menu_mob_btn.addClass("active");
				main_menu_ico.addClass("active");
			} else {
				main_menu_mob.slideUp('400');
				main_menu_mob_btn.removeClass("active");
				main_menu_ico.removeClass("active");
			}
		});

	})(jQuery);

	/* Header Search Form */
	(function ($) {
		$('.seasidetms_header_search_but').on('click', function () { 
			$('.seasidetms_header_search_form').addClass('seasidetms_show');
			
			$('.seasidetms_header_search_form').find('input[type=search]').focus();
		} );
		
		
		$('.seasidetms_header_search_form_close').on('click', function () { 
			$('.seasidetms_header_search_form').removeClass('seasidetms_show');
		} );
	} )(jQuery);

	//Stats Run
  /*
  (function ($) { 
		if ( 
			!checker.os.iphone && 
			!checker.os.ipod && 
			!checker.os.ipad && 
			!checker.os.blackberry && 
			!checker.os.android && 
			!checker.ua.ie9 
		) {
			$('.seasidetms_stats.stats_mode_circles').waypoint(function () { 
				var i = 1;
				$(this).find('.seasidetms_stat').each(function () { 
					var el = $(this);
					window.setTimeout(function () { 
						el.easyPieChart( { 
							size : 			170, 
							lineWidth : 	3, 
							lineCap : 		'square', 
							animate : 		1000, 
							scaleColor : 	false, 
							trackColor : 	false, 
							barColor : function () { 
								return ($(this.el).data('bar-color')) ? $(this.el).data('bar-color') : seasidetms_theme_script.primary_color;
							}, 
							onStep : function (from, to, val) { 
								$(this.el).find('.seasidetms_stat_counter').text(~~val);
							} 
						} );
					}, 500 * i);
					i += 1;
				} );
			}, { 
				offset : 		'100%' 
			} );
		} else {
			$('.seasidetms_stats.stats_mode_circles').find('.seasidetms_stat').easyPieChart( { 
				size : 			170, 
				lineWidth : 	3, 
				lineCap : 		'square', 
				animate : 		1000, 
				scaleColor : 	false, 
				trackColor : 	false, 
				barColor : function () { 
					return ($(this.el).data('bar-color')) ? $(this.el).data('bar-color') : seasidetms_theme_script.primary_color;
				}, 
				onStep : function (from, to, val) { 
					$(this.el).find('.seasidetms_stat_counter').text(~~val);
				} 
			} );
		}

		if ( 
			!checker.os.iphone && 
			!checker.os.ipod && 
			!checker.os.ipad && 
			!checker.os.blackberry && 
			!checker.os.android && 
			!checker.ua.ie9 
		) {
			$('.seasidetms_counters').waypoint(function () { 
				var i = 1;
				
				
				$(this).find('.seasidetms_counter').each(function () { 
					var el = $(this);
					
					
					window.setTimeout(function () { 
						el.easyPieChart( { 
							size : 			140, 
							lineWidth : 	0, 
							lineCap : 		'square', 
							animate : 		1500, 
							scaleColor : 	false, 
							trackColor : 	false, 
							barColor : 		'#ffffff', 
							onStep : function (from, to, val) { 
								$(this.el).find('.seasidetms_counter_counter').text(~~val);
							} 
						} );
					}, 500 * i);
					
					
					i += 1;
				} );
			}, { 
				offset : 		'100%' 
			} );
		} else {
			$('.seasidetms_counters').find('.seasidetms_counter').easyPieChart( { 
				size : 			140, 
				lineWidth : 	0, 
				lineCap : 		'square', 
				animate : 		1500, 
				scaleColor : 	false, 
				trackColor : 	false, 
				barColor : 		'#ffffff', 
				onStep : function (from, to, val) { 
					$(this.el).find('.seasidetms_counter_counter').text(~~val);
				} 
			} );
		}

		if ( 
			!checker.os.iphone && 
			!checker.os.ipod && 
			!checker.os.ipad && 
			!checker.os.blackberry && 
			!checker.os.android && 
			!checker.ua.ie9 
		) {
			$('.seasidetms_stats.stats_mode_bars').waypoint(function () { 
				$(this).addClass('shortcode_animated').find('.seasidetms_stat').each(function () { 
					var el = $(this);
					
					
					el.easyPieChart( { 
						size : 			140, 
						lineWidth : 	0, 
						lineCap : 		'square', 
						animate : 		1500, 
						scaleColor : 	false, 
						trackColor : 	false, 
						barColor : 		'#ffffff', 
						onStep : function (from, to, val) { 
							$(this.el).find('.seasidetms_stat_counter').text(~~val);
						} 
					} );
				} );
			}, { 
				offset : 		'100%' 
			} );
		} else {
			$('.seasidetms_stats.stats_mode_bars').addClass('shortcode_animated').find('.seasidetms_stat').easyPieChart( { 
				size : 			140, 
				lineWidth : 	0, 
				lineCap : 		'square', 
				animate : 		1500, 
				scaleColor : 	false, 
				trackColor : 	false, 
				barColor : 		'#ffffff', 
				onStep : function (from, to, val) { 
					$(this.el).find('.seasidetms_stat_counter').text(~~val);
				} 
			} );
		}
  } )(jQuery);*/

	//Responsive Navigation Function Start
	(function ($) { 
		$('#cat_menu').seasidetmsResponsiveNav();
	} )(jQuery);
} );

/*!
 * Fixed Header Function
 */
!function(e){e.fn.seasidetmsFixedHeaderScroll=function(o){var i={headerTop:".header_top",headerMid:".header_mid",headerBot:".header_bot",navBlock:"nav",navList:"#navigation_mid",navTopList:"#top_line_nav",respNavButton:".resp_bot_nav_outer",respTopNavButton:".responsive_top_nav",fixedClass:".fixed_header",fixedClassBlock:"#page",respHideBlocks:"",maxWidthMid:1024,maxWidthBot:1024,changeTopHeight:!0,changeMidHeight:!0,mobileDisabled:!0},t=this,a={};a={init:function(){a.options=a.o=e.extend({},i,o),a.el=t,a.vars=a.v={},a.v.newTopHeight=0,a.v.newMidHeight=0,a.setHeaderVars(),a.startHeader()},setHeaderVars:function(){a.v.headerMidString=a.o.headerMid,a.v.headerTop=a.el.find("> "+a.o.headerTop),a.v.headerMid=a.el.find("> "+a.v.headerMidString),a.v.headerBot=a.el.find("> "+a.o.headerBot),a.v.respNavButton=a.el.find(a.o.respNavButton),a.v.respTopNavButton=a.el.find(a.o.respTopNavButton),a.v.respHideBlocks=e(a.o.respHideBlocks),a.v.fixedClassBlock = e(a.o.fixedClassBlock),a.v.navListString=a.o.navList,a.v.navTopListString=a.o.navTopList,a.v.navBlockString=a.o.navBlock,a.v.navBlock=a.el.find(a.v.navListString).parents(a.v.navBlockString),a.v.navTopBlock=a.el.find(a.v.navTopListString).parents(a.v.navBlockString),a.v.midChangeHeightBlocks=e(a.v.headerMidString),a.v.midChangeHeightBlocksResp=e(a.v.headerMidString),a.v.topHeight=0,a.v.midHeight=a.v.headerMid.attr("data-height"),a.v.win=e(window),a.v.winScrollTop=a.v.win.scrollTop(),a.v.winMidScrollTop=a.v.winScrollTop-a.v.topHeight,a.v.isMobile="ontouchstart"in document.documentElement},startHeader:function(){a.v.headerTop.length>0&&(a.v.topHeight=a.v.headerTop.attr("data-height")),a.attachEvents(),a.v.win.trigger("scroll")},attachEvents:function(){a.v.respNavButton.bind("click",function(){return a.v.respNavButton.is(":not(.active)")?(a.v.navBlock.css({display:"block"}),a.v.respHideBlocks.css({display:"none"}),a.v.respNavButton.addClass("active")):(a.v.navBlock.css({display:"none"}),a.v.respHideBlocks.css({display:"block"}),a.v.respNavButton.removeClass("active")),!1}),a.v.respTopNavButton.bind("click",function(){return a.v.respTopNavButton.is(":not(.active)")?(a.v.navTopBlock.css({display:"block"}),a.v.respHideBlocks.css({display:"none"}),a.v.respTopNavButton.addClass("active")):(a.v.navTopBlock.css({display:"none"}),a.v.respHideBlocks.css({display:"block"}),a.v.respTopNavButton.removeClass("active")),!1}),a.v.win.bind("scroll",function(){seasidetms_media_width()>a.o.maxWidthMid&&(a.getScrollTop(),a.headerTransform())}),a.v.win.bind("resize",function(){a.v.headerBot.length>0?a.headerResize(a.o.maxWidthBot):a.headerResize(a.o.maxWidthMid)})},getScrollTop:function(){a.v.winScrollTop=a.v.win.scrollTop(),a.v.winMidScrollTop=a.v.winScrollTop-a.v.topHeight},headerTransform:function(){if(a.v.fixedClassBlock.hasClass('fixed_header')){a.v.winScrollTop<a.v.topHeight?(a.v.headerMid.removeClass("header_mid_scroll"),a.v.headerBot.removeClass("header_bot_scroll"),a.v.newTopHeight=a.v.topHeight-a.v.winScrollTop,a.v.headerTop.css({overflow:"hidden",height:a.v.newTopHeight+"px"}),a.v.winScrollTop<=3&&a.v.headerTop.css({overflow:"inherit"}),a.v.midChangeHeightBlocks.css({height:a.v.midHeight+"px"})):(a.v.headerTop.css({overflow:"hidden",height:0}),a.v.winMidScrollTop<a.v.midHeight/3?(a.v.headerMid.removeClass("header_mid_scroll"),a.v.headerBot.removeClass("header_bot_scroll"),a.v.newMidHeight=a.v.midHeight-a.v.winMidScrollTop):(a.v.headerMid.addClass("header_mid_scroll"),a.v.headerBot.addClass("header_bot_scroll"),a.v.newMidHeight=a.v.midHeight/1.5),a.v.midChangeHeightBlocks.css({height:a.v.newMidHeight+"px"}))}},headerResize:function(e){seasidetms_media_width()>e?(a.v.navBlock.removeAttr("style"),a.v.respHideBlocks.removeAttr("style"),a.v.respNavButton.removeClass("active"),a.getScrollTop(),a.headerTransform()):(a.v.headerTop.removeAttr("style"),(a.v.fixedClassBlock.hasClass('fixed_header') ? a.v.midChangeHeightBlocksResp.css("height", "auto") : ''))}},a.init()}}(jQuery);

/*!
 * Fixed Header Function 2
 */
!function(e){e.fn.seasidetmsFixedHeaderScroll=function(o){var i={headerTop:".header_top",headerMid:".header_mid",headerBot:".header_bot",navBlock:"nav",navList:"#navigation",navTopList:"#top_line_nav",respNavButton:".resp_bot_nav_outer",respTopNavButton:".responsive_top_nav",fixedClass:".fixed_header",fixedClassBlock:"#page",respHideBlocks:"",maxWidthMid:1024,maxWidthBot:1024,changeTopHeight:!0,changeMidHeight:!0,mobileDisabled:!0},t=this,a={};a={init:function(){a.options=a.o=e.extend({},i,o),a.el=t,a.vars=a.v={},a.v.newTopHeight=0,a.v.newMidHeight=0,a.setHeaderVars(),a.startHeader()},setHeaderVars:function(){a.v.headerMidString=a.o.headerMid,a.v.headerTop=a.el.find("> "+a.o.headerTop),a.v.headerMid=a.el.find("> "+a.v.headerMidString),a.v.headerBot=a.el.find("> "+a.o.headerBot),a.v.respNavButton=a.el.find(a.o.respNavButton),a.v.respTopNavButton=a.el.find(a.o.respTopNavButton),a.v.respHideBlocks=e(a.o.respHideBlocks),a.v.fixedClassBlock = e(a.o.fixedClassBlock),a.v.navListString=a.o.navList,a.v.navTopListString=a.o.navTopList,a.v.navBlockString=a.o.navBlock,a.v.navBlock=a.el.find(a.v.navListString).parents(a.v.navBlockString),a.v.navTopBlock=a.el.find(a.v.navTopListString).parents(a.v.navBlockString),a.v.midChangeHeightBlocks=e(a.v.headerMidString),a.v.midChangeHeightBlocksResp=e(a.v.headerMidString),a.v.topHeight=0,a.v.midHeight=a.v.headerMid.attr("data-height"),a.v.win=e(window),a.v.winScrollTop=a.v.win.scrollTop(),a.v.winMidScrollTop=a.v.winScrollTop-a.v.topHeight,a.v.isMobile="ontouchstart"in document.documentElement},startHeader:function(){a.v.headerTop.length>0&&(a.v.topHeight=a.v.headerTop.attr("data-height")),a.attachEvents(),a.v.win.trigger("scroll")},attachEvents:function(){a.v.respNavButton.bind("click",function(){return a.v.respNavButton.is(":not(.active)")?(a.v.navBlock.css({display:"block"}),a.v.respHideBlocks.css({display:"none"}),a.v.respNavButton.addClass("active")):(a.v.navBlock.css({display:"none"}),a.v.respHideBlocks.css({display:"block"}),a.v.respNavButton.removeClass("active")),!1}),a.v.respTopNavButton.bind("click",function(){return a.v.respTopNavButton.is(":not(.active)")?(a.v.navTopBlock.css({display:"block"}),a.v.respHideBlocks.css({display:"none"}),a.v.respTopNavButton.addClass("active")):(a.v.navTopBlock.css({display:"none"}),a.v.respHideBlocks.css({display:"block"}),a.v.respTopNavButton.removeClass("active")),!1}),a.v.win.bind("scroll",function(){seasidetms_media_width()>a.o.maxWidthMid&&(a.getScrollTop(),a.headerTransform())}),a.v.win.bind("resize",function(){a.v.headerBot.length>0?a.headerResize(a.o.maxWidthBot):a.headerResize(a.o.maxWidthMid)})},getScrollTop:function(){a.v.winScrollTop=a.v.win.scrollTop(),a.v.winMidScrollTop=a.v.winScrollTop-a.v.topHeight},headerTransform:function(){if(a.v.fixedClassBlock.hasClass('fixed_header')){a.v.winScrollTop<a.v.topHeight?(a.v.headerMid.removeClass("header_mid_scroll"),a.v.headerBot.removeClass("header_bot_scroll"),a.v.newTopHeight=a.v.topHeight-a.v.winScrollTop,a.v.headerTop.css({overflow:"hidden",height:a.v.newTopHeight+"px"}),a.v.winScrollTop<=3&&a.v.headerTop.css({overflow:"inherit"}),a.v.midChangeHeightBlocks.css({height:a.v.midHeight+"px"})):(a.v.headerTop.css({overflow:"hidden",height:0}),a.v.winMidScrollTop<a.v.midHeight/3?(a.v.headerMid.removeClass("header_mid_scroll"),a.v.headerBot.removeClass("header_bot_scroll"),a.v.newMidHeight=a.v.midHeight-a.v.winMidScrollTop):(a.v.headerMid.addClass("header_mid_scroll"),a.v.headerBot.addClass("header_bot_scroll"),a.v.newMidHeight=a.v.midHeight/1.5),a.v.midChangeHeightBlocks.css({height:a.v.newMidHeight+"px"}))}},headerResize:function(e){seasidetms_media_width()>e?(a.v.navBlock.removeAttr("style"),a.v.respHideBlocks.removeAttr("style"),a.v.respNavButton.removeClass("active"),a.getScrollTop(),a.headerTransform()):(a.v.headerTop.removeAttr("style"),(a.v.fixedClassBlock.hasClass('fixed_header') ? a.v.midChangeHeightBlocksResp.css("height", "auto") : ''))}},a.init()}}(jQuery);

/*!
 * Responsive Navigation Function
 */
!function(s){s.fn.seasidetmsResponsiveNav=function(n){var t={submenu:"ul.sub-menu, ul.children",respButton:".resp_bot_nav_outer",startWidth:1024},e=this,i={};i={init:function(){i.o=s.extend({},t,n),i.el=e,i.v={},i.v.pLinkText="",i.v.subLinkToggle=void 0,i.setVars(),i.restartNav()},setVars:function(){i.v.submenu=i.el.find(i.o.submenu),i.v.subLink=i.v.submenu.closest("li").find("> a"),i.v.respButton=s(i.o.respButton),i.v.startWidth=i.o.startWidth,i.v.win=s(window),i.v.trigger=!1,i.v.counter=0,i.startEvent()},buildNav:function(){i.v.trigger=!0,i.v.counter=1,i.v.subLink.each(function(){""===s(this).text()&&(i.v.pLinkText=s(this).closest("ul").closest("li").find("> a").text(),s(this).addClass("seasidetms_resp_nav_custom_text").html('<span class="nav_item_wrap"><span class="nav_title">'+i.v.counter+'. '+i.v.pLinkText+'</span></span>'),i.v.counter+=1),s(this).append('<span class="seasidetms_resp_nav_toggle seasidetms_theme_icon_resp_nav_slide_down" />')}),i.v.subLinkToggle=i.v.subLink.find("> span.seasidetms_resp_nav_toggle"),i.v.submenu.hide(),i.attachEvents()},restartNav:function(){!i.v.trigger&&seasidetms_media_width()<=i.v.startWidth?i.buildNav():i.v.trigger&&seasidetms_media_width()>i.v.startWidth&&i.destroyNav()},resetNav:function(){i.v.subLinkToggle.removeClass("seasidetms_theme_icon_resp_nav_slide_up").addClass("seasidetms_theme_icon_resp_nav_slide_down"),i.v.submenu.hide()},destroyNav:function(){i.v.subLink.each(function(){s(this).hasClass("seasidetms_resp_nav_custom_text")&&s(this).removeClass("seasidetms_resp_nav_custom_text").text(""),s(this).find("span.seasidetms_resp_nav_toggle").remove()}),i.v.submenu.css("display",""),i.v.trigger=!1,i.detachEvents()},startEvent:function(){i.v.win.on("resize",function(){i.restartNav()})},attachEvents:function(){i.v.subLinkToggle.on("click",function(){return s(this).hasClass("seasidetms_theme_icon_resp_nav_slide_up")?(s(this).removeClass("seasidetms_theme_icon_resp_nav_slide_up").addClass("seasidetms_theme_icon_resp_nav_slide_down").closest("li").find("ul.sub-menu, ul.children").hide(),s(this).closest("li").find("span.seasidetms_resp_nav_toggle").removeClass("seasidetms_theme_icon_resp_nav_slide_up").addClass("seasidetms_theme_icon_resp_nav_slide_down")):(s(this).removeClass("seasidetms_theme_icon_resp_nav_slide_down").addClass("seasidetms_theme_icon_resp_nav_slide_up"), s(this).closest("li").find("> ul.sub-menu, > ul.children").show(),s(this).closest("li").find("> div > ul.sub-menu, > div > ul.children").show()),!1}),i.v.respButton.on("click",function(){i.v.trigger&&s(this).hasClass("active")&&i.resetNav()})},detachEvents:function(){i.v.subLinkToggle.off("click")}},i.init()}}(jQuery);


/* Seasidetms Media Width */
function seasidetms_media_width() {
	var media_width = parseInt(jQuery('.seasidetms_responsive_width').css('width'));
	
	return media_width;
}

/* Like Button */
function seasidetmsLike(postID, add_html) {
	
	if (postID !== '') {
		var likeButton = jQuery('#seasidetmsLike-' + postID), 
			data = { 
				action : 	'seasidetms_ajax_like', 
				id : 		postID, 
				add_html : 	add_html, 
				nonce : 	seasidetms_script.nonce_ajax_like 
			};
		
		
		likeButton.find('> span').text('...');
		
		
		jQuery.post(seasidetms_script.ajaxurl, data, function(response) {	
			likeButton.find('> span').text(response);
			
			
			likeButton.addClass('active');
			
			
			likeButton.attr( { 
				onclick : 	'return false;' 
			} );
		} );
	}
	
	
	return false;
}

/* Run Owl Slider */
function seasidetms_owl_sliders_run() {
	var owl_sliders = jQuery('.seasidetms_owl_slider');
	
	
	owl_sliders.each(function () { 
		var slider = jQuery(this), 
			data = [];
		
		
		data['data_id'] = slider.attr('id');
		data['data_items'] = slider.data('items'), 
		data['data_singleItem'] = slider.data('singleItem'), 
		data['data_autoPlay'] = slider.data('autoPlay'), 
		data['data_stopOnHover'] = slider.data('stopOnHover'), 
		data['data_rewindNav'] = slider.data('rewindNav'), 
		data['data_slideSpeed'] = slider.data('slideSpeed'), 
		data['data_paginationSpeed'] = slider.data('paginationSpeed'), 
		data['data_rewindSpeed'] = slider.data('rewindSpeed'), 
		data['data_autoHeight'] = slider.data('autoHeight'), 
		data['data_transitionStyle'] = slider.data('transitionStyle'), 
		data['data_pagination'] = slider.data('pagination'), 
		data['data_navigation'] = slider.data('navigation'), 
		data['data_navigationPrev'] = slider.data('navigationPrev'), 
		data['data_navigationNext'] = slider.data('navigationNext');
		
		
		seasidetms_owl_slider_run(data);
	} );
}



/* Owl Slider run */
function seasidetms_owl_slider_run(data) {
	var data_id = data['data_id'], 
		container = jQuery('#' + data_id), 
		data_items = false, 
		data_singleItem = true, 
		data_autoPlay = false, 
		data_stopOnHover = true, 
		data_rewindNav = true, 
		data_slideSpeed = 200, 
		data_paginationSpeed = 800, 
		data_rewindSpeed = 1000, 
		data_autoHeight = (checker.ua.safari && checker.os.mac && !checker.ua.chrome) ? false : true, 
		data_transitionStyle = false, 
		data_pagination = true, 
		data_navigation = true, 
		data_navigationPrev = '<span class="seasidetms_prev_arrow"><span></span></span>', 
		data_navigationNext = '<span class="seasidetms_next_arrow"><span></span></span>', 
		params = {};
	
	
	if (data['data_items'] !== undefined) {
		data_items = Number(data['data_items']);
	}
	
	
	if (data['data_singleItem'] !== undefined) {
		data_singleItem = Boolean(data['data_singleItem']);
	}
	
	
	if (data['data_autoPlay'] !== undefined) {
		data_autoPlay = (data['data_autoPlay'] === false) ? false : Number(data['data_autoPlay']);
	}
	
	
	if (data['data_stopOnHover'] !== undefined) {
		data_stopOnHover = Boolean(data['data_stopOnHover']);
	}
	
	
	if (data['data_rewindNav'] !== undefined) {
		data_rewindNav = Boolean(data['data_rewindNav']);
	}
	
	
	if (data['data_slideSpeed'] !== undefined) {
		data_slideSpeed = Number(data['data_slideSpeed']);
	}
	
	
	if (data['data_paginationSpeed'] !== undefined) {
		data_paginationSpeed = Number(data['data_paginationSpeed']);
	}
	
	
	if (data['data_rewindSpeed'] !== undefined) {
		data_rewindSpeed = Number(data['data_rewindSpeed']);
	}
	
	
	if (data['data_autoHeight'] !== undefined) {
		data_autoHeight = Boolean(data['data_autoHeight']);
	}
	
	
	if (data['data_transitionStyle'] !== undefined) {
		data_transitionStyle = (data['data_transitionStyle'] === 'fade') ? data['data_transitionStyle'] : false;
	}
	
	
	if (data['data_pagination'] !== undefined) {
		data_pagination = Boolean(data['data_pagination']);
	}
	
	
	if (data['data_navigation'] !== undefined) {
		data_navigation = Boolean(data['data_navigation']);
	}
	
	
	if (data['data_navigationPrev'] !== undefined) {
		data_navigationPrev = data['data_navigationPrev'];
	}
	
	
	if (data['data_navigationNext'] !== undefined) {
		data_navigationNext = data['data_navigationNext'];
	}
	
	params = { 
		singleItem : 			data_singleItem, 
		autoPlay : 				data_autoPlay, 
		stopOnHover : 			data_stopOnHover, 
		rewindNav : 			data_rewindNav, 
		slideSpeed : 			data_slideSpeed, 
		paginationSpeed : 		data_paginationSpeed, 
		rewindSpeed : 			data_rewindSpeed, 
		autoHeight : 			data_autoHeight, 
		addClassActive : 		true, 
		transitionStyle : 		data_transitionStyle, 
		responsiveBaseWidth : 	'#' + data_id, 
		pagination : 			data_pagination, 
		navigation : 			data_navigation, 
		navigationText : 		[data_navigationPrev, data_navigationNext] 
	};
	
	if (data_singleItem === false) {
		if (data_items === false) {
			var contentWrap = container.closest('.content_wrap'), 
				itemsNumber = 2;
			
			
			if (contentWrap.hasClass('fullwidth')) {
				itemsNumber = 4;
			} else if (contentWrap.hasClass('r_sidebar') || contentWrap.hasClass('l_sidebar')) {
				itemsNumber = 3;
			}
		} else {
			itemsNumber = data_items;
		}
		
		
		var firstPost = container.find('.seasidetms_owl_slider_item'), 
			postMinWidth = Number(firstPost.css('minWidth').replace('px', '')), 
			postDesktopWidth = (postMinWidth * 5) - 1, 
			postDesktopSmallWidth = (postMinWidth * 4) - 1, 
			postTabletWidth = (postMinWidth * 3) - 1, 
			postMobileWidth = (postMinWidth * 2) - 1, 
			postFourColumns = (itemsNumber > 4 ? 4 : itemsNumber), 
			postThreeColumns = (itemsNumber > 3 ? 3 : itemsNumber), 
			postTwoColumns = (itemsNumber > 2 ? 2 : itemsNumber), 
			postOneColumns = 1;
		
		
		params.items = itemsNumber;
		params.itemsDesktop = [postDesktopWidth, postFourColumns];
		params.itemsDesktopSmall = [postDesktopSmallWidth, postThreeColumns];
		params.itemsTablet = [postTabletWidth, postTwoColumns];
		params.itemsMobile = [postMobileWidth, postOneColumns];
	}
	
	container.owlCarousel(params);
}
